import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import {
  addAnyConditionsNode,
  addButtonConditionsNode,
} from '../../../features/mainSlice';
import { color } from '../../../app/theme';
import Dropdown from '../../shared/Dropdown';
import { ConditionsClickType } from '../../../app/types';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 12,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    dropdown: {
      width: 328,
    },
  },
  {
    name: 'ClickType',
  },
);

const clickTypeItem = [
  { text: '任一選項', value: ConditionsClickType.ANY },
  { text: '根據卡片選項', value: ConditionsClickType.BUTTON },
];

const ClickType = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { clickType, source } = selectedNode?.data;

  const onChange = value => {
    switch (value) {
      case ConditionsClickType.ANY:
        dispatch(addAnyConditionsNode(source, selectedNode?.id));
        break;
      case ConditionsClickType.BUTTON:
      default:
        dispatch(addButtonConditionsNode(source, selectedNode?.id));
        break;
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('condition-setting.clickType')}</div>
      <Dropdown
        className={classes.dropdown}
        menuItems={clickTypeItem}
        value={clickType}
        onChange={onChange}
      />
    </div>
  );
};

export default ClickType;
